// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"fb6e899c","133":"0789f050","182":"a1bc0777","188":"be1e58aa","644":"30b742dd","917":"7c10daa1"}[chunkId] + ".chunk.js";
};